import { HttpErrorResponse, HttpEvent, HttpHandlerFn, HttpInterceptorFn, HttpRequest } from '@angular/common/http';
import { InjectionToken, inject } from '@angular/core';
import { Router } from '@angular/router';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { UserService } from '../auth/user/user.service';
import { SKIP_AUTHENTICATION } from './context/utility.context';

export const AUTH_INTERCEPTOR_HEADER = new InjectionToken<string>('AUTH_INTERCEPTOR_HEADER');

export const authInterceptor: HttpInterceptorFn = (req: HttpRequest<unknown>, next: HttpHandlerFn) => {
  const skipAuthentication = req.context.get(SKIP_AUTHENTICATION);
  if (skipAuthentication) {
    return next(req);
  }

  const userService = inject(UserService);
  const router = inject(Router);
  const headerName = inject(AUTH_INTERCEPTOR_HEADER);

  const newReq = req.clone({
    setHeaders: {
      [headerName]: userService.token
    },
    context: req.context // Preserve the context!
  });

  return next(newReq).pipe(catchError((event: HttpEvent<unknown>) => handleError(event, router)));
};

const handleError: (event: HttpEvent<unknown>, router: Router) => Observable<HttpEvent<unknown>> = (event, router) => {
  if (event instanceof HttpErrorResponse && event.status === 401) {
    // Handle unauthorized event
    router.navigate(['/knowledge-base/document-management']);
  }
  return throwError(() => event);
};
